import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import { InfoColoredIcon } from 'assets/icons';

const styles = {
  tooltip: {
    top: 0,
    '.MuiTooltip-tooltip': {
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
  },
  iconButton: {
    padding: 'unset',
  },
  icon: ({ palette }) => ({
    color: palette.info.main,
    flex: 'none',
  }),
  list: {
    paddingInlineStart: 3,
    margin: 0,
  },
};

const InfoTooltip = ({ titleText = '', items = null, placement = null }) => {
  const { isMdUp: isMdWidth } = useBreakpointFlags();
  const defaultPlacement = isMdWidth ? 'right' : 'bottom';
  const tooltipContent = items?.length ? (
    <Box component="ul" sx={styles.list}>
      {items.map((item) => (
        <Typography key={item} component="li" variant="body1" color="text.secondary">
          {item}
        </Typography>
      ))}
    </Box>
  ) : (
    <Typography variant="body1" color="text.secondary">
      {titleText}
    </Typography>
  );

  return (
    <Tooltip
      enterTouchDelay={0}
      placement={placement || defaultPlacement}
      slotProps={{ popper: { sx: styles.tooltip } }}
      title={tooltipContent}
    >
      <IconButton sx={styles.iconButton}>
        <Box component={InfoColoredIcon} sx={styles.icon} />
      </IconButton>
    </Tooltip>
  );
};

InfoTooltip.propTypes = {
  titleText: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};
export default InfoTooltip;
